export const APP_NAME = "Talking Alarm Clock";
